import { render, staticRenderFns } from "./blacklistPunishment.vue?vue&type=template&id=2d7bbb26&scoped=true"
import script from "./blacklistPunishment.vue?vue&type=script&lang=js"
export * from "./blacklistPunishment.vue?vue&type=script&lang=js"
import style0 from "./blacklistPunishment.vue?vue&type=style&index=0&id=2d7bbb26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7bbb26",
  null
  
)

export default component.exports